<template>
  <v-image :id="id" ref="image" :config="config" v-on="$listeners" />
</template>

<script>
import { filterProps } from '../../../utils/ObjectUtils';
import {
  checkImageSizeNotZero,
  loadImageAndCache,
} from '../../../utils/ImageUtils';
import { screenPrintingFilter } from '../../../utils/StageUtils';

export default {
  name: 'ConfiguratorLayerEditorStageZoneImage',
  props: {
    id: { type: String, default: undefined },
    draggable: Boolean,
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    scaleX: { type: Number, default: 1 },
    scaleY: { type: Number, default: 1 },
    rotation: { type: Number, default: 0 },
    fill: { type: String, default: undefined },
    opacity: {
      type: Number,
      default: 1,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imagePromise: undefined,
      image: undefined,
    };
  },
  computed: {
    config() {
      const config = {
        ...filterProps(this, [
          'x',
          'y',
          'scaleX',
          'scaleY',
          'rotation',
          'opacity',
          'draggable',
        ]),
      };

      if (this.fill) {
        config.filters = [this.screenPrintingFilter];
      }

      if (this.image) {
        config.image = this.image;
      }

      return config;
    },
    screenPrintingFilter() {
      return screenPrintingFilter(this.fill, 'rgba(255, 255, 255, 0)');
    },
  },
  watch: {
    url: {
      async handler(url) {
        this.imagePromise = loadImageAndCache(url);

        this.image = await this.imagePromise;

        checkImageSizeNotZero(this.image);
      },
      immediate: true,
    },
    async image() {
      await this.renderImage();
    },
  },
  methods: {
    /**
     * @return {Promise<Image>}
     */
    ready() {
      return this.imagePromise;
    },
    async renderImage() {
      await this.applyFilters();
    },
    async applyFilters() {
      await this.$nextTick();

      const imageNode = this.$refs.image.getNode();

      // See https://stackoverflow.com/a/62836435/1224564
      imageNode.cache({ pixelRatio: 0.5 });

      imageNode.getLayer().batchDraw();
    },
  },
};
</script>
